<template>
	<div class="peace-page">
		<NavMenu></NavMenu>
		<div class="scroll-container">
		    <div class="scroll-content">
				<img src="../assets/img/peace.png" class="scroll-image">
				<img src="../assets/img/peace.png" class="scroll-image">
		    </div>
		</div>
		<div class="footer">
			<div>Copyright © 2025 Gong Inc.</div> 
			<div>All rights reserved.</div>
		</div>
	</div>
</template>

<script>
	import NavMenu from '../components/nav.vue';
	export default {
		name: 'peace',
		components: {
			NavMenu,
		},
		data() {
			return {
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.peace-page {
		background-color: #48A4DC;
		width: 100%;
		height: 100vh;
		position: relative;
	}
	.peace-img {
		width: 100%;
		padding: 0 50px;
	}
	.scroll-container {
		position: absolute;
		overflow: hidden;
		white-space: nowrap;
		width: 85%; /* 或你希望的宽度 */
		margin: 0 auto;
		transform: translate(-50%, -50%);
		top: 50%;
		left: 50%;
	}
	 
	.scroll-content {
	  display: inline-block;
	  animation: scroll 10s linear infinite; /* 调整时间和速度 */
	}
	 
	.scroll-image {
		width: 100%; /* 或你希望的宽度 */
		height: auto;
		display: inline-block;
	}
	 
	@keyframes scroll {
		from { transform: translateX(0); }
		to { transform: translateX(-100%); } /* 根据图片数量和容器宽度调整 */
	}
	.footer {
		position: absolute;
		bottom: 26px;
		width: 100%;
		text-align: center;
		color: rgba(0255, 255, 255, .45);
		font-size: 10px;
	}
</style>